var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"cbo","rota-base":"/admin/cbo","titulo-singular":"CBO","campos-extras":[{"campo":"codigo","label":"Código CBO","tipo":"string","maxLength":10}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }